"use client"

import clsx from "clsx"
import { useEffect, useState } from "react"
import { CartSidebarContent } from "src/components/cart/CartSidebarContent"
import { closeCartSidebar, useCartSidebarOpened } from "src/components/cart/state"
import { useEventCallback } from "src/components/hooks/useEventCallback"
import { usePrevious } from "src/components/hooks/usePrevious"

export const CartSidebar = () => {
  const opened = useCartSidebarOpened()
  const prevOpened = usePrevious(opened)
  const [animating, setAnimating] = useState(false)

  const transitionDuration = 300
  const visible = opened || animating

  useEffect(() => {
    if (!!opened !== !!prevOpened) {
      setAnimating(true)
      setTimeout(() => {
        setAnimating(false)
      }, transitionDuration)
    }
  }, [opened, prevOpened])

  const hide = useEventCallback(() => {
    closeCartSidebar()
    setAnimating(true)
  })

  return (
    <div
      className={clsx("z-add-to-cart relative size-full transition-opacity", {
        "pointer-events-none opacity-0": !opened,
        "opacity-100": opened,
      })}
      style={{ transitionDuration: `${transitionDuration}ms` }}
    >
      {visible && <CartSidebarContent onClose={hide} />}
    </div>
  )
}
